import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  isFetched: false,
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  payload: null,
  response: null,
  updateDate: null,
};

export default type => (state = initialState, action) => {
  const switchMap = {};

  switchMap[`${type}${types.INIT}`] = () => update(state, {
    $set: initialState,
  });

  switchMap[`${type}${types.SET_PAYLOAD}`] = () => update(state, {
    payload: {
      $set: action.payload,
    },
  });

  switchMap[`${type}${types.SET_RESPONSE}`] = () => update(state, {
    response: {
      $set: action.response,
    },
  });

  switchMap[`${type}${types.FETCHING}`] = () => update(state, {
    $merge: {
      isFetched: false,
      isFetching: true,
      errorCode: 0,
      errorMsg: '',
    },
  });

  switchMap[`${type}${types.FETCHING_SUCCESS}`] = () => update(state, {
    $merge: {
      isFetched: true,
      isFetching: false,
      errorCode: 0,
      errorMsg: '',
      updateDate: Date.now(),
    },
  });

  switchMap[`${type}${types.FETCHING_FAIL}`] = () => update(state, {
    $merge: {
      isFetching: false,
      errorCode: action.errorCode,
      errorMsg: action.errorMsg,
      updateDate: Date.now(),
    },
  });

  switchMap[`${type}${types.ABORT_FETCHING}`] = () => update(state, {
    $merge: {
      isFetching: false,
    },
  });

  return switchMap[action.type]
    ? switchMap[action.type]()
    : state;
};
